(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-list"] && !Shopify.designMode) return;
  try {
    
    (function () {
        var section = document.querySelector('.category-slider-section');
        var track = document.getElementById('categoryTrack');
        var progress = document.getElementById('categoryProgress');
        var prev = document.getElementById('prevBtn');
        var next = document.getElementById('nextBtn');
        var autoplayInterval = null;

        var enableAutoplay = section.dataset.autoplay === 'true';
        var autoplaySpeed = parseInt(section.dataset.speed, 10) || 3000;
        var pauseOnHover = section.dataset.pauseOnHover === 'true';
        var desktopColumns = parseInt(section.dataset.desktopColumns, 10) || 4;
        var mobileColumns = parseInt(section.dataset.mobileColumns, 10) || 2;
        var cardWidth = 240;

        function updateProgress() {
            var maxScroll = track.scrollWidth - track.clientWidth;
            if (maxScroll <= 0) {
                progress.style.width = '100%';
                return;
            }
            var percent = (track.scrollLeft / maxScroll) * 100;
            progress.style.width = Math.min(percent, 100) + '%';
        }

        function updateArrows() {
            if (!prev || !next) return;
            var maxScroll = track.scrollWidth - track.clientWidth;

            if (track.scrollLeft <= 5) {
                prev.disabled = true;
                prev.classList.add('slider-btn--disabled');
            } else {
                prev.disabled = false;
                prev.classList.remove('slider-btn--disabled');
            }

            if (track.scrollLeft >= maxScroll - 5) {
                next.disabled = true;
                next.classList.add('slider-btn--disabled');
            } else {
                next.disabled = false;
                next.classList.remove('slider-btn--disabled');
            }
        }

        function applyColumns() {
            var isMobile = window.innerWidth <= 768;
            var columns = isMobile ? mobileColumns : desktopColumns;
            var gap = 20;
            var trackWidth = track.parentElement.offsetWidth;
            var cardW = (trackWidth - (gap * (columns - 1))) / columns;
            track.querySelectorAll('.category-card').forEach(function (card) {
                card.style.flex = '0 0 ' + cardW + 'px';
                card.style.minWidth = cardW + 'px';
            });
            cardWidth = cardW + gap;
        }

        function refreshAll() {
            applyColumns();
            updateProgress();
            updateArrows();
        }

        function scrollNext() {
            var maxScroll = track.scrollWidth - track.clientWidth;
            if (track.scrollLeft >= maxScroll - 10) {
                track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                track.scrollBy({ left: cardWidth, behavior: 'smooth' });
            }
        }

        function startAutoplay() {
            if (autoplayInterval) return;
            autoplayInterval = setInterval(scrollNext, autoplaySpeed);
        }

        function stopAutoplay() {
            clearInterval(autoplayInterval);
            autoplayInterval = null;
        }

        // Run immediately
        refreshAll();

        // Run again after DOM settles
        setTimeout(refreshAll, 100);
        setTimeout(refreshAll, 500);
        setTimeout(refreshAll, 1000);

        // Run after all images are loaded
        window.addEventListener('load', refreshAll);

        track.addEventListener('scroll', function () {
            requestAnimationFrame(function () {
                updateProgress();
                updateArrows();
            });
        });

        window.addEventListener('resize', function () {
            refreshAll();
        });

        if (next) {
            next.addEventListener('click', function () {
                stopAutoplay();
                track.scrollBy({ left: cardWidth, behavior: 'smooth' });
                if (enableAutoplay) startAutoplay();
            });
        }

        if (prev) {
            prev.addEventListener('click', function () {
                stopAutoplay();
                track.scrollBy({ left: -cardWidth, behavior: 'smooth' });
                if (enableAutoplay) startAutoplay();
            });
        }

        if (pauseOnHover) {
            track.addEventListener('mouseenter', stopAutoplay);
            track.addEventListener('mouseleave', function () {
                if (enableAutoplay) startAutoplay();
            });
        }

        track.addEventListener('touchstart', stopAutoplay, { passive: true });
        track.addEventListener('touchend', function () {
            if (enableAutoplay) setTimeout(startAutoplay, 1000);
        }, { passive: true });

        if (enableAutoplay) {
            startAutoplay();
        }

    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
